import { Doughnut , mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

/*var plugin = function (chart) {
  var width = chart.chart.width;
  var height = chart.chart.height;
  var ctx = chart.chart.ctx;

  ctx.restore();
  var fontSize = (height / 120).toFixed(2);
  ctx.font = fontSize + "em sans-serif";
  ctx.textBaseline = "middle";

  var text = 800;
  var textX = Math.round((width - ctx.measureText(text).width) / 2.75);
  var textY = height / 2;

  ctx.fillText(text, textX, textY);
  ctx.save();
}*/


export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object

  /* this.addPlugin({
     id: 'my-plugin',
     beforeDraw: plugin
   }),*/
    this.renderChart(this.chartData, this.options)
  },
  
}